<template>
  <div class="page-wrapper">
    <div class="card">

      <!-- HEADER -->
      <h2 class="page-title">📦 Master Produk</h2>

      <!-- FORM TAMBAH / EDIT -->
      <div class="form-row">
        <input
          v-model="form.name"
          type="text"
          placeholder="Nama produk"
          class="input"
        />
        <input
          v-model="form.price"
          type="number"
          placeholder="Harga (boleh kosong)"
          class="input"
        />
        <button @click="saveProduct" class="btn-primary">
          {{ form.id ? 'Update' : 'Simpan' }}
        </button>
      </div>

      <!-- SEARCH -->
      <div class="search-row">
        <input
          v-model="search"
          type="text"
          placeholder="🔍 Cari nama produk..."
          class="input search"
        />
        <button @click="search=''" class="btn-secondary">
          Reset
        </button>
      </div>

      <!-- TABLE -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Harga</th>
              <th>Status</th>
              <th class="right">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in filteredProducts" :key="p.id">
              <td class="bold">{{ p.name }}</td>
              <td>
                <span v-if="p.price !== null">
                  Rp{{ formatPrice(p.price) }}
                </span>
                <span v-else class="muted">-</span>
              </td>
              <td>
                <span
                  :class="Number(p.is_active) === 1
                    ? 'status active'
                    : 'status inactive'"
                >
                  {{ Number(p.is_active) === 1 ? 'Aktif' : 'Nonaktif' }}
                </span>
              </td>
              <td class="right">
                <button @click="editProduct(p)" class="btn-link edit">
                  Edit
                </button>
                <button
                  @click="toggleProduct(p.id)"
                  class="btn-link danger"
                >
                  {{ Number(p.is_active) === 1 ? 'Nonaktifkan' : 'Aktifkan' }}
                </button>
                <button
                    @click="confirmDelete(p)"
                    class="btn-link danger"
                    >
                    Hapus
                </button>
              </td>
            </tr>

            <tr v-if="filteredProducts.length === 0">
              <td colspan="4" class="empty">
                Produk tidak ditemukan
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ProductsList",
  data() {
    return {
      products: [],
      search: "",
      form: {
        id: null,
        name: "",
        price: ""
      }
    };
  },
  mounted() {
    this.fetchProducts();
  },
  computed: {
    filteredProducts() {
      const q = this.search.toLowerCase();
      return this.products.filter(p =>
        p.name.toLowerCase().includes(q)
      );
    }
  },
  methods: {
    async fetchProducts() {
      const res = await fetch("/api/products/list.php");
      const json = await res.json();
      this.products = json.data || [];
    },

    editProduct(p) {
      this.form = {
        id: p.id,
        name: p.name,
        price: p.price ?? ""
      };
    },

    async saveProduct() {
      if (!this.form.name.trim()) {
        alert("Nama produk wajib diisi");
        return;
      }

      const url = this.form.id
        ? "/api/products/update.php"
        : "/api/products/create.php";

      const payload = {
        id: this.form.id,
        name: this.form.name,
        price: this.form.price === "" ? null : this.form.price
      };

      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      this.resetForm();
      this.fetchProducts();
    },

    async toggleProduct(id) {
      await fetch("/api/products/toggle.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      this.fetchProducts();
    },
    async confirmDelete(product) {
        const ok = confirm(
            `⚠️ Yakin mau menghapus produk:\n\n"${product.name}"\n\nData tidak bisa dikembalikan!`
        );

        if (!ok) return;

        const res = await fetch("/api/products/delete.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: product.id })
        });

        const json = await res.json();

        if (!json.success) {
            alert(json.message || "Gagal menghapus produk");
            return;
        }

        this.fetchProducts();
    },

    resetForm() {
      this.form = { id: null, name: "", price: "" };
    },

    formatPrice(val) {
      return new Intl.NumberFormat("id-ID").format(val);
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1000px;
  margin: auto;
}

.card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* FORM */
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.input {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
}

.input.search {
  max-width: 260px;
}

/* BUTTON */
.btn-primary {
  background: #3b82f6;
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #f3f4f6;
  border-radius: 10px;
  padding: 10px 16px;
}

.btn-link {
  font-weight: 500;
  margin-left: 8px;
  border: none;
  background: none;
  cursor: pointer;
}

.btn-link.edit {
  color: #2563eb;
}

.btn-link.danger {
  color: #dc2626;
}

/* TABLE */
.table-wrapper {
  border-top: 1px solid #eee;
  margin-top: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
  padding: 14px 10px;
  font-size: 14px;
  color: #555;
}

tbody td {
  padding: 14px 10px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
}

.right {
  text-align: right;
}

.bold {
  font-weight: 500;
}

.status {
  font-weight: 600;
}

.status.active {
  color: #16a34a;
}

.status.inactive {
  color: #6b7280;
}

.empty {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
}
</style>